import React, { createContext, useContext, useReducer } from 'react';

const MortgageFlowContext = createContext();

const initialState = {
  currentStep: 'languageChoice',
  userData: {},
  messages: [],
  isComplete: false
};

const mortgageFlowReducer = (state, action) => {
  switch (action.type) {
    case 'ADD_MESSAGE':
      return {
        ...state,
        messages: [...state.messages, action.payload]
      };
    case 'UPDATE_MESSAGE':
      return {
        ...state,
        messages: state.messages.map(msg => 
          msg.id === action.payload.id ? { ...msg, ...action.payload.updates } : msg
        )
      };
    case 'UPDATE_USER_DATA':
      return {
        ...state,
        userData: { ...state.userData, ...action.payload }
      };
    case 'SET_STEP':
      return {
        ...state,
        currentStep: action.payload
      };
    case 'COMPLETE_APPLICATION':
      return {
        ...state,
        isComplete: true
      };
    case 'RESET':
      return initialState;
    default:
      return state;
  }
};

export const MortgageFlowProvider = ({ children }) => {
  const [state, dispatch] = useReducer(mortgageFlowReducer, initialState);

  const addMessage = (message) => {
    dispatch({ type: 'ADD_MESSAGE', payload: message });
  };

  const updateMessage = (messageId, updates) => {
    dispatch({ type: 'UPDATE_MESSAGE', payload: { id: messageId, updates } });
  };

  const updateUserData = (data) => {
    dispatch({ type: 'UPDATE_USER_DATA', payload: data });
  };

  const setStep = (step) => {
    dispatch({ type: 'SET_STEP', payload: step });
  };

  const completeApplication = () => {
    dispatch({ type: 'COMPLETE_APPLICATION' });
  };

  const resetFlow = () => {
    dispatch({ type: 'RESET' });
  };

  return (
    <MortgageFlowContext.Provider
      value={{
        ...state,
        addMessage,
        updateMessage,
        updateUserData,
        setStep,
        completeApplication,
        resetFlow
      }}
    >
      {children}
    </MortgageFlowContext.Provider>
  );
};

export const useMortgageFlow = () => {
  const context = useContext(MortgageFlowContext);
  if (!context) {
    throw new Error('useMortgageFlow must be used within a MortgageFlowProvider');
  }
  return context;
};